import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-deleteBin",
  "use": "icon-deleteBin-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-deleteBin\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12.58,10.25v4.67h1.17V10.25Zm-2.33,0v4.67h1.17V10.25Zm4.67-2.92h2.91V8.5H16.67v8.75a.58.58,0,0,1-.59.58H7.92a.58.58,0,0,1-.59-.58V8.5H6.17V7.33H9.08V6.17h5.84Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol